import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const AllRfq = React.lazy(() => import('.'));

export const allRfqRoutes = [
  new Route({
    path: 'all-rfq',
    element: AllRfq,
    children: [],
  }),
];
